var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "component-fade", mode: "out-in" } },
    [
      _vm.loading
        ? _c("Spinner", { key: "1", staticClass: "mt-4" })
        : _c(
            "div",
            { key: "2" },
            [
              _vm.topic
                ? _c("div", { staticClass: "mb-3" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _c("h5", { staticClass: "fw-bold" }, [
                        _vm._v(_vm._s(_vm.topic.title)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ms-auto d-flex" },
                        [
                          _c("CommunityNotifications", {
                            attrs: { topic: _vm.topic.id },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown ms-3 d-lg-none" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-dark btn-sm",
                                  attrs: {
                                    type: "button",
                                    "data-bs-toggle": "dropdown",
                                    "aria-expanded": "false",
                                  },
                                },
                                [_c("i", { staticClass: "fas fa-sliders-h" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "dropdown-menu" },
                                _vm._l(
                                  _vm.communityTopics,
                                  function (communityTopic) {
                                    return _c(
                                      "li",
                                      {
                                        key:
                                          communityTopic.id +
                                          communityTopic.title,
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "dropdown-item small fw-semibold",
                                            attrs: { href: communityTopic.url },
                                          },
                                          [_vm._v(_vm._s(communityTopic.title))]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-lg-none mt-3" }, [
                      _vm.topic.description
                        ? _c("p", { on: { click: _vm.toggleDescription } }, [
                            _vm.isDescriptionLong && !_vm.showFullDescription
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.truncatedDescription) + "…"
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.topic.description)),
                                ]),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                : _c("div", { staticClass: "mb-3 d-flex" }, [
                    _c("h5", { staticClass: "fw-bold" }, [
                      _vm._v(_vm._s(_vm._f("translate")("Community"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ms-auto d-flex" }, [
                      _c("div", { staticClass: "dropdown ms-1 d-lg-none" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-dark btn-sm",
                            attrs: {
                              type: "button",
                              "data-bs-toggle": "dropdown",
                              "aria-expanded": "false",
                            },
                          },
                          [_c("i", { staticClass: "fas fa-sliders-h" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "dropdown-menu" },
                          _vm._l(
                            _vm.communityTopics,
                            function (communityTopic) {
                              return _c(
                                "li",
                                {
                                  key: communityTopic.id + communityTopic.title,
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item small fw-semibold",
                                      attrs: { href: communityTopic.url },
                                    },
                                    [_vm._v(_vm._s(communityTopic.title))]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                    ]),
                  ]),
              _vm._v(" "),
              _vm.studentsCanPost
                ? _c("PostCreate", {
                    attrs: { topic: _vm.topic },
                    on: { postCreated: _vm.postCreated },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.noPosts
                ? _c("div", { staticClass: "text-center" }, [
                    _c("img", {
                      staticClass: "w-50 mt-5 mb-3",
                      attrs: { src: "/images/undraw_empty_xct9.svg", alt: "" },
                    }),
                    _vm._v(" "),
                    _c("h3", { staticClass: "fw-light" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("translate")("Oops... Nothing here yet")
                          ) +
                          "\n      "
                      ),
                    ]),
                  ])
                : _c(
                    "div",
                    _vm._l(_vm.posts, function (post) {
                      return _c("Post", { key: post.id, attrs: { post: post } })
                    }),
                    1
                  ),
              _vm._v(" "),
              _c("div", { staticClass: "d-grid" }, [
                _vm.next_page_url
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-link",
                        attrs: { disabled: _vm.loadingMore },
                        on: { click: _vm.loadMorePosts },
                      },
                      [
                        _c(
                          "transition",
                          { attrs: { name: "component-fade", mode: "out-in" } },
                          [
                            _vm.loadingMore
                              ? _c("span", [
                                  _c("span", {
                                    staticClass:
                                      "spinner-border spinner-border-sm",
                                    attrs: {
                                      role: "status",
                                      "aria-hidden": "true",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "visually-hidden" },
                                    [_vm._v("Loading...")]
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(_vm._s(_vm._f("translate")("More"))),
                                ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }